function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: "32px",
    height: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface855061"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "black",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 5.5 4.085938 L 4.085938 5.5 L 4.796875 6.203125 L 14.585938 16 L 4.085938 26.5 L 5.5 27.914062 L 16 17.414062 L 25.789062 27.210938 L 26.5 27.914062 L 27.914062 26.5 L 27.210938 25.789062 L 17.414062 16 L 27.914062 5.5 L 26.5 4.085938 L 16 14.585938 L 6.203125 4.796875 Z M 5.5 4.085938 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.59c7fd4099b68c9cb9acef75463ead78.svg";
export { ForwardRef as ReactComponent };